export const iconFontAwesomeShoppingStore = (
	<i className="fa-solid fa-store"></i>
);
